export const _SET_ATTRIBUTE = (attributes) => {
  return {
    type: "SET_ATTRIBUTE",
    payload: attributes,
  };
};
